/**
 * Which auth endpoint a URL is, for the two decisions the response interceptors make. They were one
 * predicate until change-password arrived and needed opposite answers from each.
 *
 * Kept out of `http-client.ts` because that module imports `./api`, which reaches back to the store
 * that constructs the client — importing it from a test hits the cycle before the class is defined.
 */

/** Answers with a fresh `x-auth` / `x-refresh-token` pair that the tab has to store. */
export const issuesTokenPair = (url: string | undefined): boolean =>
  /\/auth\/(google|login|change-password|set-password)/.test(url ?? '');

/**
 * A 401 here is a wrong password rather than a dead session, so it must not clear storage and reload.
 * change-password is deliberately absent: it is `@Authorized()`, so its 401 *is* a dead session.
 */
export const isSignInUrl = (url: string | undefined): boolean => /\/auth\/(google|login)/.test(url ?? '');

/**
 * A reload after a 401 lands on a sign-in page, unless the URL still carries the link's `?token`: the
 * reloaded page exchanges that same dead token again, and gets the same 401, forever.
 */
export const reloadsIntoSameRefresh = (url: string | undefined, search: string): boolean =>
  /\/auth\/refresh/.test(url ?? '') && new URLSearchParams(search).has('token');
